import { useState } from "react";

export function useOrdenacao(dados, setDados) {
  //   const [dados, setDados] = useState(dadosIniciais);
  const [ordem, setOrdem] = useState({ coluna: null, direcao: "asc" });

  const ordenar = (index, key) => {
    console.log(key);
    if (key === "acoes") {
      return;
    }

    const novaDirecao =
      ordem.coluna === key && ordem.direcao === "asc" ? "desc" : "asc";

    const ordenado = [...dados].sort((a, b) => {
      const valor1 = a[key];
      const valor2 = b[key];

      if (typeof valor1 === "number" && typeof valor2 === "number") {
        return novaDirecao === "asc" ? valor1 - valor2 : valor2 - valor1;
      }

      (valor1 ?? "").toString().toLowerCase();
      (valor2 ?? "").toString().toLowerCase();

      if (valor1 < valor2) return novaDirecao === "asc" ? -1 : 1;
      if (valor1 > valor2) return novaDirecao === "asc" ? 1 : -1;
      return 0;
    });

    setDados(ordenado);
    setOrdem({ coluna: key, direcao: novaDirecao });
  };

  return { dados, ordenar, ordem, setDados };
}
